import DOMPurify from 'dompurify'

// Dono único da allowlist de HTML escrito pelo modelo de IA. Consumida por
// `@modules/global/components/aawz-markdown-render` (renderizador da
// plataforma) e `@modules/aawz-intelligence-v2/components/ia-markdown`; antes
// cada um carregava uma cópia e qualquer endurecimento tinha de ser feito duas
// vezes (SHOULD 8 do review do PR #2041).
//
// Perfil `html` do DOMPurify (que já exclui SVG/MathML) MENOS as tags que o
// sanitizador legado por regex — `aawz-intelligence-v2/utils/sanitize-ia-html.js`
// — também removia. A troca por DOMPurify existe para endurecer o filtro, então
// não pode afrouxar o que já era bloqueado: `img` num chat multi-tenant é pixel
// de exfiltração (a URL sai com o dado que o modelo colocar nela), e controle
// de formulário não aparece em resposta nenhuma — `prompt_ia_operacional.py`
// instrui as personas a emitirem apenas <div class> e <span class>.
export const TAGS_PROIBIDAS = Object.freeze([
  'script',
  'style',
  'iframe',
  'object',
  'embed',
  'img',
  'form',
  'input',
  'button',
  'textarea',
  'select',
  'base',
  'link',
  'meta',
])

// Os `on*` são redundantes — o DOMPurify remove todo handler inline por conta
// própria — e estão aqui como declaração de intenção. O `style` NÃO é
// redundante: é ele que mantém a regra do design-system de que cor e
// espaçamento vêm de classe, nunca de estilo escrito pelo modelo.
//
// `target` ([I-6] do review do PR #2086): `<a target="_blank">` sem
// `rel="noopener noreferrer"` dá à página aberta acesso a `window.opener`
// (reverse-tabnabbing) e vaza o Referer — que aqui carrega
// `id_escritorio`/`id_cliente` na URL da conversa. Entre permitir o `target` e
// carimbar o `rel` num hook, ou PROIBIR o `target`, escolhemos o lado fechado:
// o link abre na mesma aba e a conversa continua no histórico do browser. O
// DOMPurify desta versão já o removia por default — a diferença é que aqui
// está declarado, e não depende do perfil `html` continuar decidindo assim.
export const ATRIBUTOS_PROIBIDOS = Object.freeze([
  'onerror',
  'onload',
  'onclick',
  'style',
  'target',
])

export const OPCOES_DOMPURIFY = Object.freeze({
  USE_PROFILES: Object.freeze({ html: true }),
  FORBID_TAGS: TAGS_PROIBIDAS,
  FORBID_ATTR: ATRIBUTOS_PROIBIDOS,
})

export function sanitizarHtml(html) {
  return DOMPurify.sanitize(html, OPCOES_DOMPURIFY)
}
